import type { IDataType } from "~/solidJs/shared/helpers/types/INodeDefinition";

export enum SocketCustomErrorMessageType {
	EmptyNonOptional = "emptyNonOptional"
}

type ErrosAccordType<ErrorType> = Partial<Record<SocketCustomErrorMessageType, ErrorType>>;
type NamedErrorFunction = (socketName: string) => string;
export class SocketCustomErrorMessage {
	errorsAccordDataType: Partial<Record<IDataType, ErrosAccordType<NamedErrorFunction>>> = {
		image: {
			[SocketCustomErrorMessageType.EmptyNonOptional]: (socketName) =>
				`Connect your image to "${socketName}"`
		}
	};
	errorsAccordSocketName: Partial<Record<string, ErrosAccordType<string>>> = {
		text_prompt: {
			[SocketCustomErrorMessageType.EmptyNonOptional]:
				"Write the prompt and press Generate again"
		},
		prompt: {
			[SocketCustomErrorMessageType.EmptyNonOptional]:
				"Write the prompt and press Generate again"
		},
		description: {
			[SocketCustomErrorMessageType.EmptyNonOptional]:
				"Write the prompt and press Generate again"
		}
	};
	constructor(
		public socketName: string,
		public dataType: IDataType,
		public displayName: string,
		public errorTypeToCustomMessageMap?: ErrosAccordType<string>
	) {}

	getErrorMessage(errorType: SocketCustomErrorMessageType): string | undefined {
		return (
			this.getCustomMessage(errorType) ??
			this.getMessageBySocketName(errorType) ??
			this.getErrorMessageAccordSocketDataType(errorType)
		);
	}

	private getCustomMessage(errorType: SocketCustomErrorMessageType): string | undefined {
		return this.errorTypeToCustomMessageMap?.[errorType];
	}

	private getMessageBySocketName(errorType: SocketCustomErrorMessageType): string | undefined {
		return this.errorsAccordSocketName[this.socketName]?.[errorType];
	}

	private getErrorMessageAccordSocketDataType(
		errorType: SocketCustomErrorMessageType
	): string | undefined {
		return this.errorsAccordDataType[this.dataType]?.[errorType]?.(this.displayName);
	}
}
